

function btnDate() {
  const ContDate = document.getElementById('cont-date');
  const spanDate = ContDate.querySelector('span')
  document.addEventListener('click', (e) => {
    let click = e.composedPath().includes(ContDate);
    if (!click) {
      spanDate.style.display = 'block';
    } else {
      spanDate.style.display = 'none';
    }
  })
}

function BtnGroup() {
  const BtnContainer = document.querySelector('.interview__buttons');
  const Buttons = BtnContainer.querySelectorAll('button');
  Buttons.forEach((button) => {
    button.addEventListener('click', function () {
      Buttons.forEach((button) => {
        button.classList.remove('active');
      })
      this.classList.add('active');
    })
  })
}

function BtnChoice() {
  const BtnContainer = document.querySelector('.interview__choice--buttons');
  const Buttons = BtnContainer.querySelectorAll('button');
  Buttons.forEach((button) => {
    button.addEventListener('click', function () {
      Buttons.forEach((button) => {
        button.classList.remove('true');
      })
      this.classList.add('true');
    })
  })

}

function Buttons() {
  btnDate()
  BtnGroup()
  BtnChoice()
}

export {
  Buttons,
}
